import { useNavigate } from 'react-router-dom';
import { clearSession } from '../utils/tokenGuard';

export interface HotelContext {
  hotelId: number | null;
  hotelName: string | null;
  hotelSlug: string | null;
}

export function useAuth() {
  const navigate = useNavigate();

  const token       = localStorage.getItem('guest_token');
  const profileRaw  = localStorage.getItem('guest_profile');
  const profile     = profileRaw ? JSON.parse(profileRaw) : null;

  const hotelContext: HotelContext = {
    hotelId:   localStorage.getItem('guest_hotel_id')   ? Number(localStorage.getItem('guest_hotel_id'))   : null,
    hotelName: localStorage.getItem('guest_hotel_name') || null,
    hotelSlug: localStorage.getItem('guest_hotel_slug') || null,
  };

  const isAuthenticated = !!token;

  function logout() {
    clearSession();
    navigate('/expired');
  }

  return { token, profile, isAuthenticated, logout, hotelContext };
}

/**
 * Persist hotel context fields to localStorage.
 * Called after a successful bind or profile refresh.
 */
export function saveHotelContext(hotelId?: number | null, hotelName?: string | null, hotelSlug?: string | null) {
  if (hotelId   != null) localStorage.setItem('guest_hotel_id',   String(hotelId));
  if (hotelName != null) localStorage.setItem('guest_hotel_name', hotelName);
  if (hotelSlug != null) localStorage.setItem('guest_hotel_slug', hotelSlug);
}
